import React from 'react';
import ScoreRing from './ScoreRing';

const s = {
  wrap: { animation: 'fadeUp 0.5s ease both' },
  topbar: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '24px', marginBottom: '32px', paddingBottom: '28px', borderBottom: '1px solid var(--border)', flexWrap: 'wrap' },
  companyName: { fontFamily: 'var(--font-head)', fontSize: 'clamp(24px, 3vw, 40px)', fontWeight: 900, color: '#fff', letterSpacing: '0.06em', marginBottom: '10px' },
  meta: { fontFamily: 'var(--font-mono)', fontSize: '13px', color: 'var(--text2)', display: 'flex', gap: '18px', flexWrap: 'wrap' },
  metaItem: { display: 'flex', alignItems: 'center', gap: '6px' },
  statRow: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '20px' },
  statCard: { background: 'var(--panel)', border: '1px solid var(--border)', borderRadius: '6px', padding: '20px 24px', position: 'relative', overflow: 'hidden' },
  statBefore: { position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: 'linear-gradient(90deg, var(--neon), transparent)' },
  statLabel: { fontFamily: 'var(--font-mono)', fontSize: '11px', color: 'var(--text2)', letterSpacing: '0.15em', marginBottom: '8px' },
  statVal: { fontFamily: 'var(--font-head)', fontSize: '16px', color: '#fff', fontWeight: 700 },
  panelFull: { marginBottom: '16px' },
  panels: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' },
  panel: { background: 'var(--panel)', border: '1px solid var(--border)', borderRadius: '6px', padding: '24px' },
  panelTitle: { fontFamily: 'var(--font-head)', fontSize: '11px', color: 'var(--neon)', letterSpacing: '0.2em', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' },
  panelBody: { fontSize: '15px', color: 'var(--text)', lineHeight: 1.9 },
  listItems: { display: 'flex', flexDirection: 'column', gap: '12px' },
  listItem: { display: 'flex', alignItems: 'flex-start', gap: '12px', fontSize: '14px', color: 'var(--text)', lineHeight: 1.6 },
  bullet: { width: '18px', height: '18px', borderRadius: '3px', flexShrink: 0, marginTop: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-mono)', fontSize: '10px' },
  tags: { display: 'flex', flexWrap: 'wrap', gap: '8px' },
  tag: { fontFamily: 'var(--font-mono)', fontSize: '12px', letterSpacing: '0.08em', padding: '6px 14px', borderRadius: '3px' },
  verdict: { background: 'linear-gradient(135deg, rgba(0,255,231,0.05), rgba(123,92,255,0.05))', border: '1px solid var(--border2)', borderRadius: '6px', padding: '28px 32px', position: 'relative', overflow: 'hidden', marginBottom: '28px' },
  verdictBar: { position: 'absolute', top: 0, left: 0, bottom: 0, width: '4px', background: 'linear-gradient(180deg, var(--neon), var(--neon2))' },
  verdictLabel: { fontFamily: 'var(--font-head)', fontSize: '11px', color: 'var(--neon)', letterSpacing: '0.2em', marginBottom: '12px' },
  verdictText: { fontSize: '16px', color: '#fff', lineHeight: 1.8, fontStyle: 'italic' },
  verdictReason: { fontFamily: 'var(--font-mono)', fontSize: '12px', color: 'var(--text2)', marginTop: '12px' },
  footer: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: '24px', borderTop: '1px solid var(--border)', flexWrap: 'wrap', gap: '14px' },
  footerMeta: { fontFamily: 'var(--font-mono)', fontSize: '11px', color: 'var(--text3)' },
  actionRow: { display: 'flex', gap: '12px' },
  btnGhost: { fontFamily: 'var(--font-head)', fontSize: '11px', letterSpacing: '0.15em', padding: '12px 22px', border: '1px solid var(--border2)', borderRadius: '3px', background: 'transparent', color: 'var(--neon)', cursor: 'pointer' },
  btnSolid: { fontFamily: 'var(--font-head)', fontSize: '11px', letterSpacing: '0.15em', padding: '12px 22px', border: '1px solid var(--neon)', borderRadius: '3px', background: 'var(--neon)', color: 'var(--bg)', cursor: 'pointer', fontWeight: 700 },
};

function Bullet({ type }) {
  const map = {
    green: { background: 'rgba(0,255,231,0.15)', color: 'var(--neon)', border: '1px solid rgba(0,255,231,0.4)' },
    red: { background: 'rgba(255,60,110,0.12)', color: 'var(--neon3)', border: '1px solid rgba(255,60,110,0.4)' },
    blue: { background: 'rgba(123,92,255,0.15)', color: 'var(--neon2)', border: '1px solid rgba(123,92,255,0.4)' },
  };
  const labels = { green: '+', red: '!', blue: '→' };
  return <div style={{ ...s.bullet, ...map[type] }}>{labels[type]}</div>;
}

function PanelTitle({ children }) {
  return (
    <div style={s.panelTitle}>
      {children}
      <div style={{ flex: 1, height: '1px', background: 'var(--border)' }} />
    </div>
  );
}

export default function Report({ data, onReset }) {
  return (
    <div style={s.wrap}>
      <div style={s.topbar}>
        <div>
          <div style={s.companyName}>{data.companyName}</div>
          <div style={s.meta}>
            {[data.industry, data.founded, data.hq].map((item, i) => (
              <div key={i} style={s.metaItem}><span style={{ color: 'var(--text3)' }}>//</span>{item}</div>
            ))}
          </div>
        </div>
        <ScoreRing score={data.investmentScore} />
      </div>

      <div style={s.statRow}>
        {[['INDUSTRY', data.industry], ['FOUNDED', data.founded], ['HEADQUARTERS', data.hq]].map(([label, val]) => (
          <div key={label} style={s.statCard}>
            <div style={s.statBefore} />
            <div style={s.statLabel}>{label}</div>
            <div style={s.statVal}>{val}</div>
          </div>
        ))}
      </div>

      <div style={s.panelFull}><div style={s.panel}><PanelTitle>OVERVIEW</PanelTitle><div style={s.panelBody}>{data.overview}</div></div></div>

      <div style={s.panels}>
        <div style={s.panel}><PanelTitle>MARKET POSITION</PanelTitle><div style={s.panelBody}>{data.marketPosition}</div></div>
        <div style={s.panel}><PanelTitle>RECENT DEVELOPMENTS</PanelTitle><div style={s.panelBody}>{data.recentNews}</div></div>
      </div>

      <div style={s.panels}>
        <div style={s.panel}><PanelTitle>STRENGTHS</PanelTitle><div style={s.listItems}>{(data.strengths||[]).map((item,i)=><div key={i} style={s.listItem}><Bullet type="green"/>{item}</div>)}</div></div>
        <div style={s.panel}><PanelTitle>RISKS</PanelTitle><div style={s.listItems}>{(data.risks||[]).map((item,i)=><div key={i} style={s.listItem}><Bullet type="red"/>{item}</div>)}</div></div>
      </div>

      <div style={s.panels}>
        <div style={s.panel}><PanelTitle>OPPORTUNITIES</PanelTitle><div style={s.listItems}>{(data.opportunities||[]).map((item,i)=><div key={i} style={s.listItem}><Bullet type="blue"/>{item}</div>)}</div></div>
        <div style={s.panel}>
          <PanelTitle>COMPETITORS</PanelTitle>
          <div style={s.tags}>{(data.competitors||[]).map((c,i)=><span key={i} style={{...s.tag,color:'var(--text2)',border:'1px solid var(--border)',background:'transparent'}}>{c}</span>)}</div>
          <div style={{height:'18px'}}/>
          <PanelTitle>TAGS</PanelTitle>
          <div style={s.tags}>{(data.tags||[]).map((t,i)=><span key={i} style={{...s.tag,color:'var(--neon)',border:'1px solid rgba(0,255,231,0.3)',background:'rgba(0,255,231,0.07)'}}>{t}</span>)}</div>
        </div>
      </div>

      <div style={s.verdict}>
        <div style={s.verdictBar}/>
        <div style={s.verdictLabel}>// AGENT VERDICT</div>
        <div style={s.verdictText}>{data.verdict}</div>
        <div style={s.verdictReason}>Score rationale: {data.scoreReason}</div>
      </div>

      {data.dataPoints?.length > 0 && (
        <div style={{...s.panelFull, marginBottom:'28px'}}>
          <div style={s.panel}>
            <PanelTitle>KEY DATA POINTS</PanelTitle>
            <div style={s.listItems}>
              {data.dataPoints.map((point,i)=>(
                <div key={i} style={s.listItem}>
                  <div style={{...s.bullet,background:'rgba(123,92,255,0.15)',color:'var(--neon2)',border:'1px solid rgba(123,92,255,0.4)',fontSize:'9px'}}>0{i+1}</div>
                  {point}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <div style={{display:'flex',gap:'12px',marginBottom:'24px',flexWrap:'wrap'}}>
        <div style={{fontFamily:'var(--font-mono)',fontSize:'12px',color:'var(--neon2)',border:'1px solid rgba(123,92,255,0.3)',background:'rgba(123,92,255,0.07)',padding:'7px 16px',borderRadius:'3px'}}>
          ◈ TRUE AGENT — {data.researchSteps||4} AUTONOMOUS RESEARCH LOOPS
        </div>
        <div style={{fontFamily:'var(--font-mono)',fontSize:'12px',color:'var(--neon)',border:'1px solid var(--border)',padding:'7px 16px',borderRadius:'3px'}}>
          ✦ POWERED BY CLAUDE + WEB SEARCH
        </div>
      </div>

      <div style={s.footer}>
        <div style={s.footerMeta}>GENERATED: {new Date().toUTCString().toUpperCase()} · NEXUS AI</div>
        <div style={s.actionRow}>
          <button style={s.btnGhost} onClick={onReset}>NEW SEARCH</button>
          <button style={s.btnSolid} onClick={()=>window.print()}>EXPORT REPORT</button>
        </div>
      </div>
    </div>
  );
}
